import { render, staticRenderFns } from "./MsgElementText_Text.vue?vue&type=template&id=d1e2e590"
import script from "./MsgElementText_Text.vue?vue&type=script&lang=js"
export * from "./MsgElementText_Text.vue?vue&type=script&lang=js"
import style0 from "./MsgElementText_Text.vue?vue&type=style&index=0&id=d1e2e590&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports